import React, { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Navigate, useNavigate } from "react-router";
import AdminLayout from "../../components/layouts/adminLayout";
import { AuthContext } from "../../context/authContext";
import AuthServices from "../../services/authServices";
import MyAccountService from "../../services/API/MyAccountManager";
import { validateChangePasswordFormData } from "../../utils/utils";
import { localStorageKeys } from "../../constant/keys";

const initial = {
  currentPassword: "",
  newPassword: "",
  confirmPassword: "",
};

export default function ForceChangePassword() {
  const auth = useContext(AuthContext);
  const navigate = useNavigate();
  const [passwordFormData, setPasswordFormData] = useState(initial);
  const [isPasswordShow, setIsPasswordShow] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!auth?.isAuthenticated) return;
    if (!auth?.mustChangePassword) navigate("/", { replace: true });
  }, [auth?.isAuthenticated, auth?.mustChangePassword, navigate]);

  if (!auth?.isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }

  const handleChange = (e) => {
    const { value, name } = e.target;
    setPasswordFormData({ ...passwordFormData, [name]: value.trim() });
  };

  const submitForm = async (e) => {
    e.preventDefault();
    const error = validateChangePasswordFormData(passwordFormData);
    if (error) {
      toast.error(error);
      return;
    }
    setLoading(true);
    try {
      const res = await MyAccountService.changePasswordService(passwordFormData);
      if (res?.status_code === 200) {
        toast.success("Password updated. Please log in with your new password.");
        await AuthServices.logout({ type: "change-password" });
        localStorage.removeItem(localStorageKeys.aparajithaData);
        auth.setIsAuthenticated(false);
        auth.setMustChangePassword(false);
        navigate("/admin/login");
      }
    } catch (error) {
      toast.error(error.message);
      setPasswordFormData(initial);
    }
    setLoading(false);
  };

  return (
    <AdminLayout sideMenu={false} footer={false}>
      <div
        style={{
          background: "url(/img/screen-background.png)",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
        className="d-flex flex-column justify-content-center align-items-center h-100"
      >
        <div className="col-lg-4 col-md-6 col-sm-10">
          <div className="card card-lg">
            <div className="card-body">
              <h2 className="mb-2">Password Update Required</h2>
              <p className="text-muted mb-4">
                Your password is more than 90 days old. Please set a new password to continue.
              </p>
              <form onSubmit={submitForm}>
                <div className="mb-4">
                  <label className="form-label font-md" htmlFor="currentPassword">
                    Current Password<span style={{ color: "red" }}> *</span>
                  </label>
                  <input
                    type="password"
                    className="form-control"
                    name="currentPassword"
                    id="currentPassword"
                    placeholder="Enter current password"
                    value={passwordFormData.currentPassword}
                    onChange={handleChange}
                    autoComplete="off"
                  />
                </div>
                <div className="mb-4 position-relative">
                  <label className="form-label font-md" htmlFor="newPassword">
                    New Password<span style={{ color: "red" }}> *</span>
                  </label>
                  <i
                    className={`position-absolute hover:cursor-pointer fa ${isPasswordShow ? "fa-eye" : "fa-eye-slash"}`}
                    style={{ right: "10px", top: "60%" }}
                    onMouseOver={() => setIsPasswordShow(true)}
                    onFocus={() => setIsPasswordShow(true)}
                    onMouseOut={() => setIsPasswordShow(false)}
                    onBlur={() => setIsPasswordShow(false)}
                  ></i>
                  <input
                    type={isPasswordShow ? "text" : "password"}
                    className="form-control eyeOne"
                    name="newPassword"
                    id="newPassword"
                    placeholder="Enter new password"
                    value={passwordFormData.newPassword}
                    onChange={handleChange}
                    autoComplete="off"
                  />
                </div>
                <div className="mb-5">
                  <label className="form-label font-md" htmlFor="confirmPassword">
                    Confirm Password<span style={{ color: "red" }}> *</span>
                  </label>
                  <input
                    type="password"
                    className="form-control"
                    name="confirmPassword"
                    id="confirmPassword"
                    placeholder="Re-enter new password"
                    value={passwordFormData.confirmPassword}
                    onChange={handleChange}
                    autoComplete="off"
                  />
                </div>
                <div className="d-grid gap-4">
                  <button
                    type="submit"
                    className="btn btn-primary btn-lg"
                    disabled={loading}
                  >
                    {loading ? "Updating..." : "Update Password"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
}
